import React, { useState } from "react";
import "./index.css"
export const Patners = () => {

    return (

        <div className="container-art">
            <div className="container-art-1 my-3">
                <div className="d-flex justify-content-center align-item-center">
                    <div className="lead-sub">Our Values Business Patners</div>
                </div>
                <br />
                <div className="container">
                    <div className="row">
                        {[1, 2, 3, 4, 5, 6]?.map((d, index) => {
                            return (
                                <div className="col-6 col-md-2 col-lg-2 mb-3" key={index}>
                                    <div className="patners-border">
                                    </div>
                                </div>)
                        })}

                    </div>
                </div>
            </div>
        </div>

    );
};

